var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.571,21.856c-2,2-2,4-4,4s-4-2-6-4-4-4-4-6,2-2,4-4-4-8-6-8-6,6-6,6c0,4,4.109,12.109,8,16s12,8,16,8c0,0,6-4,6-6s-6-8-8-6Z","transform":"translate(-2.571 -3.856)"}));
}

Phone.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = Phone;

Phone.default = Phone;
